<template>
  <div>
    <div class="comm_popup_wrap_xlarge">
      <sui-grid
        ref="grdList"
        :columns="gridColumns0"
        :dataset="'dataset0'"
      />
      <div class="comm_btn_wrap mrB30">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onClickClose"
        >
          {{ $t('MSG_BTN_CLOSE') }}
        </sui-button>
      </div>
    </div>
  </div>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CLB_00003_P01',
  components: {},
  extends: BasePage,
  props: {
    bbsId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  datasets: [
    {
      id: 'dataset0',
      type: 'local',
      data: 'localdata0',
      datafields: [
        {
          name: 'postUID',
          type: 'string',
          map: 'postUID',
        },
        {
          name: 'rowNumber',
          type: 'string',
          map: 'rowNumber',
        },
        {
          name: 'qnaNoticeObjTextTitle',
          type: 'string',
          map: 'qnaNoticeObjTextTitle',
        },
      ],
    },
  ],
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  created() {
    this.localdata0 = [];
    this.gridColumns0 = [
      {
        text: this.$t('MSG_TXT_SN'),
        datafield: 'rowNumber',
        width: '80px',
      },
      {
        text: this.$t('MSG_TXT_TITLE'),
        datafield: 'qnaNoticeObjTextTitle',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onClickRow,
            type: 'link',
          }, this.dataset0, this.$refs.grdList);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
    ];
  },
  methods: {
    onLoad() {
      http.request(this.contextPageId, 'DTS_CLB_00069', {
        query: {
          bbsId: this.bbsId,
        },
      }).then(res => {
        this.dataset0.setRawData(res.data);
      });
    },
    onClickRow(btn, selectedRow) {
      if (selectedRow) {
        utils.openLayerPopup('PGE_CLB_00022', this.popUpClosedCallback, {
          size: 'xlg',
          pageInitialData: {
            postIdParam: selectedRow.postUID,
            bbsId: this.bbsId,
            bbsName: this.bbsName,
            isCategoryGroupExist: this.isCategoryGroupExist,
          },
        });        
      }
    },
    onClickClose() {
      this.$emit('close');
    },
    popUpClosedCallback() {
      this.onLoad();
    },
  },
};
</script>
<style scoped>
</style>
